<template>
  <v-dialog max-width="400px" v-model="dialog" persistent>
    <v-card>
      <v-alert type="error" v-if="message" class="body-2 font-weight-regular">
        {{ message }}
      </v-alert>
      <v-card-text>
        <CollectCard @token="addCard"></CollectCard>
      </v-card-text>
      <v-card-actions>
        <v-btn  text @click="dialog = false"> Cancel {{ cardCollectCount }} / 10 left</v-btn>
        <!-- <v-btn  text @click="dialog = false"> Cancel {{ cardCollectCount }} / 10 left</v-btn> -->
        <v-spacer></v-spacer>
        <v-btn color="primary" :loading="isLoading" @click="submit">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import settingsService from "@/modules/BackOffice/service.js";
import locationService from "@/modules/Location/service.js";
import CollectCard from "@/components/CollectCard.vue"
import EventBus from '@/event-bus.js'

export default {
  props: ['message', 'alert', 'openDialog'],
  data() {
    return {
      isLoading: false,
      dialog: false,
      token: null,
      cardCollectCount: 10
    };
  },
  components: {
    CollectCard
  },
  watch: {
    openDialog(val) {
      if (val) {
        this.dialog = val
        const count = localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}cardCollectCount`);
        console.log('cardCollectCount count', count)
        if (count) {
          this.cardCollectCount = parseInt(count)
          console.log('cardCollectCount', this.cardCollectCount)
          this.cardCollectCount = this.cardCollectCount - 1
            localStorage.setItem(`${process.env.VUE_APP_STORAGE_PREFIX}cardCollectCount`, this.cardCollectCount);
        } else {
          localStorage.setItem(`${process.env.VUE_APP_STORAGE_PREFIX}cardCollectCount`, 10);
        }
        // console.log('cardCollectCount', this.cardCollectCount)
      }
    }
  },
  methods: {
    submit() {
      EventBus.$emit('get-card');
    },
    async addCard(data) {
      // console.log('this.kldjfd', this.$root)
      // console.log('e', e)
      try {
        this.isLoading = true;
        // const data = await this.pay();
        // const stripeResponse =
        const newCard = await locationService.addCard({ source: data.token.id });
        console.log('newCard', newCard)
        this.$emit("reloadCard");
        // this.loadCards();
        this.dialog = false;
        this.isLoading = false;
      } catch (error) {
        console.log("error", error);
        this.isLoading = false;
        this.$toast.error(error.data ? error.data.message : "Error", {
          timeout: 2000,
        });
        // this.$toasted.error(error.message, {
        //   position: "top-right",
        //   showHideTransition: "slide",
        //   duration: 3500,
        // });
      }
    },
  },

};
</script>

